$(function () {
    const $form = $("#listing-shortlist-form");
    const $saveButton = $("#save-listing");
    const $removeButton = $("#remove-listing");
    const $loading = $("#shortlist-loading");
    const $failure = $("#shortlist-fail");

    function showShortlisted(shortlisted) {
        $saveButton.toggle(!shortlisted);
        $removeButton.toggle(shortlisted);
    }

    $form.on("click", "button[name='bookmark']", function (event) {
        event.preventDefault();
        const $button = $(this);
        const adding = $button.val() === "true";
        const advertId = parseInt($form.find("input[name='advertId']").val());
        const formData = $form.serializeArray();
        formData.push({ name: $button.attr("name"), value: $button.val() });
        $button.hide();
        $failure.hide();
        $loading.show();

        $.ajax({
            url: $form.attr("action"),
            type: "POST",
            data: formData,
            success: function (results) {
                var shortlisted = $.inArray(advertId, results) >= 0;
                if (shortlisted === adding) {
                    showShortlisted(shortlisted);
                } else {
                    $failure.show();
                    $button.show();
                }
                $loading.hide();
            },
            error: function (response) {
                if (response.status === 401 || response.status === 403) {
                    $('<input type="hidden">').attr({ name: $button.attr("name"), value: $button.val() }).appendTo($form);
                    $form[0].submit();
                } else {
                    $failure.show();
                    $button.show();
                    $loading.hide();
                }
            }
        });
    });
});